<template>
  <span>
    <span v-if="onlyYingshi" style="cursor:pointer" @click="showYinsi()">隐私政策</span>
    <span v-if="!onlyYingshi">
      <a @click.stop="showYinsi()">《隐私政策》</a
      ><a @click.stop="showYonghuxy()">《赛码用户协议》</a></span
    >
    <el-dialog
      class="private-dialog"
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      :width="dialogWidth"
      padding="30px"
    >
      <pre class="dialogHtml" v-html="dialogHtml"></pre>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisible = false"
          >我知道了</el-button
        >
      </span>
    </el-dialog>
  </span>
</template>

<script>
import { LOGIN_API } from "@/api.js";
export default {
  props: ['onlyYingshi'],
  name:'secrect-control',
  data() {
    return {
      confirm: {},
      dialogTitle: '',
      dialogVisible: false,
      dialogHtml: '',

      dialogWidth: '650px',
      isMobile: false,
    }
  },

  mounted() {
    this.loadDataYonghuxieyi()
    this.loadDataYinsi()
    this.isMobile = this.$store.state.app.device
    if (this.isMobile) {
      this.dialogWidth = '96%'
    }
  },
  methods: {
    loadDataYonghuxieyi() {
      let post = {
        category: 38,
      }
      this.$axios
        .post(`${LOGIN_API}/customer/api/config`, post)
        .then((res) => {
          if (res.data.errno == 0) {
            if (res.data.result && res.data.result.length > 0) {
              this.confirm.yonghuxieyi = res.data.result[0].data
            }
          } else {
            this.$message.error(res.data.errmsg)
          }
        })
    },
    loadDataYinsi() {
      let post = {
        category: 39,
      }
      this.$axios
        .post(`${LOGIN_API}/customer/api/config`, post)
        .then((res) => {
          if (res.data.errno == 0) {
            if (res.data.result && res.data.result.length > 0) {
              this.confirm.yingsi = res.data.result[0].data
            }
          } else {
            this.$message.error(res.data.errmsg)
          }
        })
    },
    showYinsi() {
      this.dialogTitle = '隐私政策'
      this.dialogHtml = this.confirm.yingsi
      this.dialogVisible = true
    },
    showYonghuxy() {
      this.dialogTitle = '赛码用户协议'
      this.dialogHtml = this.confirm.yonghuxieyi
      this.dialogVisible = true
    },
  },
}
</script>

<style lang="scss" scoped>
a {
  color: #29bdb9;
  cursor: pointer;
}
.dialogHtml {
  max-height: 400px;
  overflow: auto;
  overflow: auto;
  font-weight: normal;
  margin: 0px;
  text-align: left;
  white-space: pre-wrap;
}
.el-button {
  background: #29bdb9;
  border: 0;
  border-radius: 2px;
  font-size: 14px;
  line-height: 28px;
  padding: 5px 25px;
  letter-spacing: 0.5px;
  &:hover {
    background-color: rgba($color: #29bdb9, $alpha: 0.6);
  }
}
</style>
<style lang="scss">
.private-dialog {
  .el-dialog__header {
    padding-top: 20px !important;
  }
}
.v-modal {
  z-index: 200 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/secrect/index.vue